import { render } from "./RecordNavigation.vue?vue&type=template&id=e7bd00c6"
import script from "./RecordNavigation.vue?vue&type=script&lang=js"
export * from "./RecordNavigation.vue?vue&type=script&lang=js"

import "./RecordNavigation.vue?vue&type=style&index=0&id=e7bd00c6&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.27.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__